import dayjs from 'dayjs';
import { MandateStatus } from 'app/shared/model/enumerations/mandate-status.model';

export interface IMandate {
  id?: number;
  bankAccountId?: number;
  mandateReference?: string;
  status?: keyof typeof MandateStatus;
  signatureId?: number | null;
  signedAt?: dayjs.Dayjs | null;
  entranceCode?: string;
  createdAt?: dayjs.Dayjs;
  updatedAt?: dayjs.Dayjs | null;
  transactionUrl?: string | null;
  mandateTransactionCreateRequestKey?: string | null;
  mandateTransactionResponseKey?: string | null;
  mandateStatusResponseKey?: string | null;
}

export const defaultValue: Readonly<IMandate> = {};
